import axios from 'axios'

const API = axios.create({
  baseURL: process.env.REACT_APP_LANDING_PAGE_SERVICE_URL
})

export default API